/**
 * Storage permissions.
 *
 * @id - Used to identify the rule on permissions and upload.
 * @folder - Folder where the files will be saved
 * @maxSizeInBytes - Max allowed size in bytes
 * @bypassWritingPermissions - Does not validate if the user has permission to write
 * @publicRead - The file can be publicly accessed via the URL without the need for a signed token
 */

export const Storage = {
    workspacePhoto: {
        id: 'workspacePhoto',
        folder: 'tenant/:tenantId/workspace/photo',
        maxSizeInBytes: 100 * 1024 * 1024
    },
    itemImages: {
        id: 'itemImages',
        folder: 'tenant/:tenantId/item/images',
        maxSizeInBytes: 100 * 1024 * 1024
    },
    itemProductionReadyFiles: {
        id: 'itemProductionReadyFiles',
        folder: 'tenant/:tenantId/item/productionReadyFiles',
        maxSizeInBytes: 100 * 1024 * 1024
    },
    itemOtherFiles: {
        id: 'itemOtherFiles',
        folder: 'tenant/:tenantId/item/otherFiles',
        maxSizeInBytes: 100 * 1024 * 1024
    },

    settingsLogos: {
        id: 'settingsLogos',
        folder: 'tenant/:tenantId/settings/logos',
        maxSizeInBytes: 10 * 1024 * 1024,
        publicRead: true
    },
    settingsBackgroundImages: {
        id: 'settingsBackgroundImages',
        folder: 'tenant/:tenantId/settings/backgroundImages',
        maxSizeInBytes: 10 * 1024 * 1024,
        publicRead: true
    },
    userAvatarsProfiles: {
        id: 'userAvatarsProfiles',
        folder: 'user/avatars/profile/:userId',
        maxSizeInBytes: 10 * 1024 * 1024,
        bypassWritingPermissions: true,
        publicRead: true
    }
};
